import { IconChevronDown } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { AppLoader } from '../../../AppLoader/AppLoader';

type SelectSuffixIconProps = {
    loading?: boolean;
    suffixIcon?: ReactNode;
};

export const SelectSuffixIcon = ({ loading, suffixIcon }: SelectSuffixIconProps) => {
    const theme = useTheme();

    if (loading) {
        return <AppLoader size={20} />;
    }

    if (suffixIcon) {
        return suffixIcon;
    }

    return <IconChevronDown color={theme.colors.grayscale.gray8} aria-label="Otwórz listę opcji" />;
};
